
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexYlV1yMx41hR65rsstCyJtuVcXtXzp9RaItwiTeYCuIkMeta } from "/app/build/products/Survey/pages/index.vue?macro=true";
import { default as invite9cTi5PPgi4uaKZ08Fm7Xo_45fZHix0iivCX0m5WI_45kXBYMeta } from "/app/build/products/Survey/pages/invite.vue?macro=true";
import { default as signinkVmisEyRzUgWMMWy1c9TNFRVTlVhKpyrk9faluM7vbkMeta } from "/app/build/products/Survey/pages/admin/auth/signin.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    component: () => import("/app/build/products/Survey/pages/index.vue")
  },
  {
    name: "index___uk",
    path: "/uk",
    component: () => import("/app/build/products/Survey/pages/index.vue")
  },
  {
    name: "index___ru",
    path: "/ru",
    component: () => import("/app/build/products/Survey/pages/index.vue")
  },
  {
    name: "invite___en",
    path: "/invite",
    component: () => import("/app/build/products/Survey/pages/invite.vue")
  },
  {
    name: "invite___uk",
    path: "/uk/invite",
    component: () => import("/app/build/products/Survey/pages/invite.vue")
  },
  {
    name: "invite___ru",
    path: "/ru/invite",
    component: () => import("/app/build/products/Survey/pages/invite.vue")
  },
  {
    name: "admin-auth-signin___en",
    path: "/admin/auth/signin",
    component: () => import("/app/build/products/Survey/pages/admin/auth/signin.vue")
  },
  {
    name: "admin-auth-signin___uk",
    path: "/uk/admin/auth/signin",
    component: () => import("/app/build/products/Survey/pages/admin/auth/signin.vue")
  },
  {
    name: "admin-auth-signin___ru",
    path: "/ru/admin/auth/signin",
    component: () => import("/app/build/products/Survey/pages/admin/auth/signin.vue")
  }
]